interface PageLayoutProps {
    children: React.ReactNode;
    backgroundColor?: string;
  }
  
  const PageLayout: React.FC<PageLayoutProps> = ({ children, backgroundColor }) => {
    const isRTL = BResource.isRTL();
  
    return (
      <div dir={isRTL ? 'rtl' : 'ltr'} className={`PageLayout absolute block h-screen w-screen ${backgroundColor ?? 'bg-base-bg-default'} text-base-txt-primary`}>
        {children}
      </div>
    );
  };
  
  export default PageLayout;
  